
import Vue from 'vue';
import IconNotificationInfo from '@/components/icons/icon-notification-info.svg';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'InfoBoxWarning',
  components: {
    IconNotificationInfo
  }
})
export default class InfoBoxWarning extends Vue {
  @Prop({ default: 'Ihre Daten konnten nicht geladen werden. Bitte versuchen Sie es später noch einmal.' })
  private text: string;
}
